// Brand assets + shared content constants

export const ASSETS = {
  labelLogo:
    "https://customer-assets-jai6qajn.emergentagent.net/job_85d967f5-5b17-4f52-bc94-b5d5bf86dc62/artifacts/qv9rt5g2_Elegant%20Circle%20Signature%20Photography%20Logo.png",
  kssrLogo: "/brand/kssr-logo.png",
  kssrBanner: "/brand/kssr-banner.png",
  messagesLogo:
    "https://customer-assets-jai6qajn.emergentagent.net/job_85d967f5-5b17-4f52-bc94-b5d5bf86dc62/artifacts/t2466xh8_MESSAGES%20logo.jpg",
  messagesLogoV2:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_heavy-music-ui/artifacts/6rfrktqv_MESSAGES%20Band%20Logo.jpg",
  messagesPress:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_heavy-music-ui/artifacts/pooaguu6_MESSAGES%20Press%20Photo%20.webp",
};

export const TEXTURES = {
  concrete:
    "https://images.unsplash.com/photo-1578662996442-48f60103fc96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxkYXJrJTIwY29uY3JldGUlMjB0ZXh0dXJlfGVufDB8fHx8MTc4NDgyMDEzMnww&ixlib=rb-4.1.0&q=85",
  crowd:
    "https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxtZXRhbCUyMGNvbmNlcnQlMjBjcm93ZHxlbnwwfHx8fDE3ODQ4MjAxMzJ8MA&ixlib=rb-4.1.0&q=85",
  gothic:
    "https://images.unsplash.com/photo-1562362898-d1a9d124fd77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxnb3RoaWMlMjBhcmNoaXRlY3R1cmUlMjBkYXJrfGVufDB8fHx8MTc4NDgyMDEzMnww&ixlib=rb-4.1.0&q=85",
};

export const GOOGLE_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSdPkXVMm5kO24mAytNQnBI-FSaL8XUeIj_cMXKoeTGdZjoA9g/viewform?usp=header";

export const SOCIALS = {
  instagram: "https://www.instagram.com/sorrowandserenityrecords",
  facebook:
    "https://www.facebook.com/people/Sorrow-and-Serenity-Music/61592784327809/",
};

export const MESSAGES_LINKS = {
  instagram: "https://www.instagram.com/wearemessages",
  facebook: "https://www.facebook.com/wearemessagesmetal/",
  spotify:
    "https://open.spotify.com/artist/7655bN7xZKrtgQVyLbsW7w?si=Q5eA0W75TaCHTqW7NerADQ",
  presave:
    "https://distrokid.com/hyperfollow/messages1/come-alive?ref=release",
  pathRadio: "https://thepathradio.com",
};
